import { OneEducationCoreModule } from '@oneeducation/app-core';
import { DividerModule } from 'primeng/divider';
import { SharedModule } from '@shared/shared.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { MessageModule } from 'primeng/message';
import { SelectModule } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { CheckboxModule } from 'primeng/checkbox';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { AccordionModule } from 'primeng/accordion';
import { MultiSelectModule } from 'primeng/multiselect';
import { ListboxModule } from 'primeng/listbox';
import { CardModule } from 'primeng/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { SplitButtonModule } from 'primeng/splitbutton';
import {
  StudentSummaryComponent,
  ViewPupilListComponent,
  StudentExclusionListComponent,
  StudentExclusionDetailsComponent,
  StudentExclusionComponent,
  ExclusionSupportOfficersComponent,
  ExclusionReasonsComponent,
  StudentExclusionLinkedDocumentListComponent,
  ExclusionOverviewComponent,
  ExclusionMeetingsComponent,
  AcademicSummaryViewComponent
} from './components';
import { UserManagementModule } from '@usermanagement/user-management.module';
import { DatePickerModule } from 'primeng/datepicker';
import { InputNumberModule } from 'primeng/inputnumber';

@NgModule({
  declarations: [
    ViewPupilListComponent,
    StudentSummaryComponent,
    StudentExclusionListComponent,
    StudentExclusionDetailsComponent,
    StudentExclusionComponent,
    ExclusionSupportOfficersComponent,
    ExclusionReasonsComponent,
    StudentExclusionListComponent,
    StudentExclusionLinkedDocumentListComponent,
    ExclusionOverviewComponent,
    ExclusionMeetingsComponent,
    AcademicSummaryViewComponent
  ],
  imports: [
    CommonModule,
    MessageModule,
    FormsModule,
    ReactiveFormsModule,
    TableModule,
    SelectModule,
    InputTextModule,
    CheckboxModule,
    ButtonModule,
    DialogModule,
    UserManagementModule,
    SharedModule,
    DividerModule,
    AccordionModule,
    CardModule,
    MultiSelectModule,
    ListboxModule,
    OneEducationCoreModule,
    ConfirmDialogModule,
    SplitButtonModule,
    DatePickerModule,
    InputNumberModule
  ],
  exports: [
    ViewPupilListComponent,
    StudentSummaryComponent,
    StudentExclusionListComponent,
    StudentExclusionDetailsComponent,
    StudentExclusionComponent,
    ExclusionSupportOfficersComponent,
    ExclusionReasonsComponent,
    StudentExclusionLinkedDocumentListComponent,
    ExclusionOverviewComponent,
    ExclusionMeetingsComponent,
    AcademicSummaryViewComponent
  ]
})
export class ExclusionModule {}
